/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Agence.css';
import Helmet from 'react-helmet';
import fetch from '../../core/fetch';
import HeightMatchingGroup from 'react-height-matching-group';

const title = 'Agence';

@withStyles(s)
export default class Agence extends Component {
    
	constructor(props) {
        super(props);

        this.state = {
            agence: [],
            loader: true,
        };
    
    }

    componentDidMount(){

        this.GetAgence();

    }

    async GetAgence(){
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{agence{id, slug, title, content, equipe, fondement, partenaire}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.agence) throw new Error('Erreur sur le chargement de la page agence !');

        if(data){
            this.setState({ loader: false })
        }
        
        this.setState({ agence: data.agence })
    }

    render(){

        const appear = this.state.loader ? 'appear' : '';
       
        var background = {
            backgroundColor: '#008eef'
        }

        const topContent = <div dangerouslySetInnerHTML={{ __html: this.state.agence.content }} />;
        const equipe = <div dangerouslySetInnerHTML={{ __html: this.state.agence.equipe }} />;
        const fondement = <div dangerouslySetInnerHTML={{ __html: this.state.agence.fondement }} />;
        const partenaire = <div dangerouslySetInnerHTML={{ __html: this.state.agence.partenaire }} />;

	    return (
	        <div className={s.root}>
	            <Helmet title={title} meta={[{"name": "description", "content": "Agence Web, Notre Équipe, Notre Mission, Nos Fondements, Nos Certifications, Témoignages"}]}/>
                <div className={`spinner ${appear}`} style={background}></div>
	            <div id="agence" className={`agence`}>
                    <div className={`bgHeaderAgence`}>
                        <div className={`container`}>
                            <div className={`content`}>
                                {topContent}
                            </div>
                        </div>
                    </div>
                    <main role="main">
                        {equipe}
                        {fondement}
                        {partenaire}
                    </main>
                </div>
            </div>
	    );
    }
}





// WEBPACK FOOTER //
// ./containers/agence/Agence.js